import {
  Box,
  Section,
  SectionContent,
  SectionTitle,
  smBumps,
  Typo,
  xlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote, getPolicyholder } from '../../../domain'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { useUpButton } from '../../../infrastructure/routing'
import { getProduct, ManagementType, useConfig } from '../../../state/configuration'
import { toDateTime } from '../../../util/date'
import { AppPath } from '../../AppPath'
import { ReferralReasons } from '../../organisms/quote'
import { WriskTrans } from '../../organisms/trans'
import { FullPage } from '../../templates'
import { useProduct } from '../ProductProvider'
import { useProposal } from '../proposal/ProposalProvider'
import { AdditionalProfileManagement } from './components/AdditionalProfileManagement'
import { QuoteManagement } from './components/QuoteManagement'

const tKey = TKey('pages.renewal-referral')

export const RenewalReferralPage: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  const upButton = useUpButton({ url: AppPath.HOME, id: 'home' })

  const { proposal } = useProposal()
  const { scheme } = useProduct()
  const {
    renewal: { sections },
  } = useConfig(getProduct(scheme.schemeCode))

  const quote = getCurrentQuote(proposal)
  const profile = getPolicyholder(quote)

  const subheader = (
    <WriskTrans
      t={t}
      i18nKey={tKey('subheader')}
      values={{
        startAt: t(tFormats('datetime.medium'), { value: toDateTime(proposal.startAt) }),
      }}
    />
  )

  const configuredSections = sections.map((it) => {
    const content = (() => {
      switch (it.type) {
        case ManagementType.ADDITIONAL_PROFILE:
          return <AdditionalProfileManagement config={it} quote={quote} />
        default:
          return <QuoteManagement config={it} quote={quote} />
      }
    })()

    return (
      <Section key={it.id} width={1} mb={xlBumps}>
        <SectionTitle>{t(tKey('sections', it.id))}</SectionTitle>
        <SectionContent>{content}</SectionContent>
      </Section>
    )
  })

  return (
    <FullPage
      pageId='renewal-reverral'
      header={t(tKey('header'), { profile })}
      subheader={subheader}
      upButton={upButton}
    >
      <ReferralReasons quote={quote} mb={smBumps} width={1} />
      <Box width={1} mb={xlBumps}>
        <Typo typoSize='sm'>{t(tKey('check-details'))}</Typo>
      </Box>
      {configuredSections}
    </FullPage>
  )
}
